import { AuthLayout } from "../../Layouts";

export const PasswordlessLoginPage = () => {
  return <AuthLayout></AuthLayout>;
};
